import { PageContentContainer } from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { Button } from "@fp/ui/components/base/buttons/button";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { CheckCircle, ChevronRight } from "@untitledui/icons";
import { getGetRoleByIdQueryOptions } from "@fp/admin-api-client/client";
import { FloatingAddButton } from "@fp/ui/components/base/buttons/floating-add-button";

export const Route = createFileRoute("/settings/roles/$id/")({
	loader: async ({ context: { queryClient }, params }) => {
		const role = await queryClient.fetchQuery(
			getGetRoleByIdQueryOptions(params.id),
		);
		return {
			role: role.data,
		};
	},
	component: RouteComponent,
});

function RouteComponent() {
	const router = useRouter();
	const { id } = Route.useParams();
	const { role } = Route.useLoaderData();

	return (
		<AdminLayout>
			<AdminPageHeader
				title={role.name ?? "Unknown"}
				parent={{ url: "/settings/roles", label: "Roles" }}
				titleActions={
					role.users && role.users.length > 0 ? (
						<FloatingAddButton
							onClick={() => {
								router.navigate({
									to: `/settings/roles/${id}/edit`,
								});
							}}
						/>
					) : undefined
				}
			/>
			<PageContentContainer className="bg-gray-50 px-0 pb-0 pt-0">
				<div className="flex flex-col overflow-auto flex-grow">
					{/* User List or No Users Message */}
					{role.users && role.users.length > 0 ? (
						<div className="bg-white border border-gray-200">
							{role.users.map((user, index) => (
								<div
									key={user.id}
									className={`flex items-center px-4 py-4 ${
										index < role.users!.length - 1
											? "border-b border-gray-200"
											: ""
									}`}
								>
									<ChevronRight className="h-5 w-5 text-gray-400 mr-3" />
									<span className="text-gray-900">
										{user.fullName ||
											`${user.firstName || ""} ${user.lastName || ""}`.trim() ||
											user.email}
									</span>
								</div>
							))}
						</div>
					) : (
						<div className="p-4">
							<h3 className="text-lg font-medium text-gray-900 mb-1">
								Assigned {role.name}s
							</h3>
							<p className="text-gray-500 text-sm">
								No {role.name}s assigned yet
							</p>
						</div>
					)}

					{/* Description section */}
					<div className="p-4">
						<p className="text-gray-700 text-base leading-relaxed">
							Admins can do the following things this is the descriptive text
							that explains how cool Admins are
						</p>
					</div>

					{/* Permissions list */}
					<div className="p-4">
						<div className="space-y-4">
							{role.permissions?.map((permission) => (
								<div
									key={permission.id}
									className="flex items-center space-x-3"
								>
									<CheckCircle className="h-6 w-6 text-fieldpay-blue-600 flex-shrink-0" />
									<span className="text-gray-700 text-base">
										{permission.name}
									</span>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Assign button */}
				<div className="p-4 text-center bg-white shadow">
					<Button
						color="primary"
						size="lg"
						className="w-full max-w-md py-3"
						onClick={() => {
							router.navigate({
								to: `/settings/roles/${id}/edit`,
							});
						}}
					>
						Assign {role.name}
					</Button>
				</div>
			</PageContentContainer>
		</AdminLayout>
	);
}
